export default class Modifier {
  constructor ({ filter, value, count }) {
    Object.assign(this, { filter, value, count })
  }

  async applicable ({ character, raw, ui, type, context }) {
    if (Modifier.NON_MODIFIABLE_TYPES.includes(type))  return false
    return await character.getRawValue({ raw: this.filter, ui, type: 'boolean', context, fallback: false })
  }

  static async calculate (modifiers, { character, raw, ui, type, context }) {
    let sum = 0
    for(const modifier of modifiers) {
      const applicable = await modifier.applicable({ character, raw, ui, type, context })
      if (applicable) {
        modifier.tick()
        sum += await character.get(modifier.value, { ui, type, context })
      }
    }

    return sum
  }

  tick () {
    if (this.count > 0) {
      this.count = this.count - 1
    }
    if (this.count === 0) {
      this.used = true
    }
  }

  // Serialization
  toJson () {
    return Modifier.serialize(this)
  }

  static deserialize (json) {
    return new Modifier(json)
  }

  static serialize (modifier) {
    return {
      filter: modifier.filter,
      value: modifier.value,
      once: modifier.once
    }
  }
}

Modifier.NON_MODIFIABLE_TYPES = 'procedure range formula text'.split(' ')
